'use client';

import { ForgotPasswordCard } from '@eliadmin/core/src/components/nt/account/password/forgot-password-card';
import { PasswordForm } from '@eliadmin/core/src/components/nt/account/password/password-form';
import { AccountHeading } from '@eliadmin/core/src/components/nt/account/shell/account-card';
import { useAccountTexts } from '@eliadmin/core/src/components/nt/shared/site-texts';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

/**
 * „Zmena hesla“ (Figma 207:11374): the heading, then „Layout“ – the password card beside the 340 px
 * side column (24 px apart) once the content column has room (800 px), stacked otherwise. The
 * designed „Zabezpečenie účtu“ card is left out: the customer record has neither the last password
 * change nor the last sign-in, and the card has nothing else to show.
 */
export function PasswordView() {
  const { t } = useTranslations();
  const texts = useAccountTexts();
  const me = useCustomerStore(s => s.me);
  if (!me) return null;

  return (
    <div className="flex flex-col gap-4">
      <AccountHeading title={t('text115')} text={texts.passwordText} />
      <div className="grid items-start gap-4 @[50rem]:grid-cols-[minmax(0,1fr)_minmax(280px,340px)] @[50rem]:gap-6">
        <PasswordForm email={me.customer.email} authToken={me.authToken} />
        <aside className="flex min-w-0 flex-col gap-4">
          <ForgotPasswordCard email={me.customer.email} />
        </aside>
      </div>
    </div>
  );
}
